import { FallbackProps } from 'react-error-boundary';

import { ErrorState } from './error-state/ErrorState';
import { useTranslation } from 'contexts/translation-context';

export const ErrorFallback: React.FC<FallbackProps> = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  const { i18n } = useTranslation();

  return (
    <div className="w-full h-full p-8">
      <ErrorState error={error} onRetry={resetErrorBoundary} retryLabel={i18n('errors.reloadPage')} variant="page" />
    </div>
  );
};
